export enum SchedulingProjectStatusEnum {
  Importing = "Importing",
  Planning = "Planning",
  Active = "Active",
  Executing = "Executing",
  Closed = "Closed"
}
